import { LinearProgress, linearProgressClasses } from '@mui/material';

import { white } from '~components/theme/styles/colors';
import { getAssetConfig } from '~config/protocol';
import { EVestaAsset } from '~config/types';

type ProgressBarProps = {
  color?: string;
  asset?: EVestaAsset;
  value: number;
  isLoading: boolean;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ color, asset, value, isLoading }) => {
  const progressBarColor = asset ? getAssetConfig(asset).styles.gradient : color;

  return (
    <LinearProgress
      variant={isLoading ? 'indeterminate' : 'determinate'}
      sx={{
        [`.${linearProgressClasses.bar}`]: { background: progressBarColor },
        height: '2px',
        backgroundColor: white['15%'],
      }}
      value={value}
    />
  );
};
